import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../Buttons/Button';
import MultipleSelectionHint from '../../Selection/MultipleSelectionHint';

import './TablesSelectorActions.scss';

type Props = {
    onAddTables: () => void;
    onClose: () => void;
};

const TablesSelectorActions = ({ onAddTables, onClose }: Props) => {
    return (
        <div className="table-selector-action">
            <MultipleSelectionHint />
            <div className="table-selector-action-actions">
                <Button variant="flat" className="small" onClick={onClose}>
                    <FormattedMessage id="cancel" />
                </Button>
                <Button
                    variant="contained"
                    className="small"
                    onClick={onAddTables}
                >
                    <FormattedMessage id="add" />
                </Button>
            </div>
        </div>
    );
};

export default TablesSelectorActions;
